import React from 'react'
import { colors } from '../../Colors'

export interface IProps {
    width?: number
    height?: number
    color?: string
}

const AdminIcon = ({ width = 24, height = 24, color = colors.grey[50] }: IProps) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 24 24' fill='none'>
            <path
                d='M12.199 3C11.7747 3 11.3677 3.16857 11.0677 3.46863C10.7676 3.76869 10.599 4.17565 10.599 4.6C10.5992 4.88983 10.678 5.17418 10.8272 5.42269C10.9763 5.67119 11.1902 5.87451 11.4459 6.01094L8.28184 11.9438L3.97715 9.41094C4.12207 9.16524 4.19868 8.88526 4.19902 8.6C4.19902 8.17565 4.03045 7.76869 3.73039 7.46863C3.43034 7.16857 3.02337 7 2.59902 7C2.17468 7 1.76771 7.16857 1.46765 7.46863C1.16759 7.76869 0.999023 8.17565 0.999023 8.6C0.999023 9.02435 1.16759 9.43131 1.46765 9.73137C1.76771 10.0314 2.17468 10.2 2.59902 10.2C2.65227 10.1995 2.70546 10.1964 2.7584 10.1906L3.39902 16.6H5.79902H16.199H18.599H20.999L21.6396 10.1922C21.6926 10.1974 21.7458 10.2 21.799 10.2C22.2234 10.2 22.6303 10.0314 22.9304 9.73137C23.2305 9.43131 23.399 9.02435 23.399 8.6C23.399 8.17565 23.2305 7.76869 22.9304 7.46863C22.6303 7.16857 22.2234 7 21.799 7C21.3747 7 20.9677 7.16857 20.6677 7.46863C20.3676 7.76869 20.199 8.17565 20.199 8.6C20.1994 8.88526 20.276 9.16524 20.4209 9.41094L16.1162 11.9438L12.9521 6.01094C13.2079 5.87451 13.4217 5.67119 13.5709 5.42269C13.72 5.17418 13.7989 4.88983 13.799 4.6C13.799 4.17565 13.6305 3.76869 13.3304 3.46863C13.0303 3.16857 12.6234 3 12.199 3ZM3.39902 18.2V19.8C3.39902 20.684 4.11502 21.4 4.99902 21.4H19.399C20.283 21.4 20.999 20.684 20.999 19.8V18.2H3.39902Z'
                fill={color}
            />
        </svg>
    )
}

export default React.memo(AdminIcon)
